module.exports = __webpack_public_path__ + "img/plane-hanging.a90b6582.svg";